import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { changeNegativePrompt } from '../../../../redux/form/actions';
import { getNegativePrompt } from '../../../../redux/form/selectors';
import GrowingTextArea from '@wix/da-ds/pkg/formControls/lego/GrowingTextArea';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
const NegativePromptTextArea = (props)=>{
    const { t } = useTranslation('dreamup');
    const dispatchChangeNegativePrompt = useAction(changeNegativePrompt);
    const negativePrompt = useSelector(getNegativePrompt);
    return /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement(VisuallyHidden, null, t('dreamup.header.settingsPanel.negativePromptInput.a11y.label')), /*#__PURE__*/ React.createElement(GrowingTextArea, _object_spread({
        placeholder: t('dreamup.header.settingsPanel.negativePromptInput.placeholder'),
        value: negativePrompt,
        maxLength: 400,
        onChange: (e)=>{
            dispatchChangeNegativePrompt(e.target.value.trimStart());
        }
    }, props)));
};
NegativePromptTextArea.displayName = 'NegativePromptTextArea';
export default NegativePromptTextArea;

//# sourceMappingURL=NegativePromptTextArea.js.map